import { TUserType } from '@unionco/alaris-app-types'

type TStringBoolean = 'true' | 'false'

export const isAdminTracking = (userType: TUserType): TStringBoolean => {
  return userType === 'admin' ? 'true' : 'false'
}
